import { homeApi } from "@/api/homeApi";
import { userInfoDao } from "@/api/userInfoDao";
import userSettingsApi from "@/api/userSettingsApi";
import { ConfigDomain, mapConfigDtoToDomain } from "@/types/Config";
import { HomeInfoDomain, mapHomeInfoDtoToDomain } from "@/types/HomeInfo";
import { UserInfoDomain, mapUserInfoDomainToDb,mapUserInfoDbToDomain } from "@/types/UserInfo";
import { mapUserInfoDtoToDomain } from "@/types/UserInfo";
import {
  UserSubscriptionDomain,
  mapUserSubscriptionDtoToDomain,
} from "@/types/UserSubscription";

export interface UserInfoRepository {
  getHomeInfo: () => Promise<HomeInfoDomain>;
  getUserSubscription: () => Promise<UserSubscriptionDomain | null>;
  getUserInfo: () => Promise<UserInfoDomain | null>;
  isEnabledPushNotifications: () => boolean;
  setIsEnabledPushNotifications: (isEnabled: boolean) => void;
  getConfig: () => Promise<ConfigDomain | null>;
  clearUserInfo: () => void;
}

export const userInfoRepository: UserInfoRepository = {
  getHomeInfo: (() => {
    let homeInfoPromise: Promise<HomeInfoDomain> | null = null;

    return async () => {
      if (homeInfoPromise) {
        return homeInfoPromise;
      }

      homeInfoPromise = performGetHomeInfo();

      try {
        const result = await homeInfoPromise;
        return result;
      } finally {
        homeInfoPromise = null;
      }
    };

    async function performGetHomeInfo(): Promise<HomeInfoDomain> {
      try {
        const homeInfo = await homeApi.getMainMenu();
        return mapHomeInfoDtoToDomain(homeInfo);
      } catch (error) {
        console.error("Ошибка при получении главного меню:", error);
        throw error;
      }
    }
  })(),
  
  getUserInfo: (() => {
    let userInfoPromise: Promise<UserInfoDomain | null> | null = null;

    return async () => {
      if (userInfoPromise) {
        return userInfoPromise;
      }

      userInfoPromise = performGetUserInfo();

      try {
        const result = await userInfoPromise;
        return result;
      } finally {
        userInfoPromise = null;
      }
    };

    async function performGetUserInfo(): Promise<UserInfoDomain | null> {
      try {

        const userInfoDb = await userInfoDao.getUserInfo();

        if (userInfoDb) {
          return await mapUserInfoDbToDomain(userInfoDb);
        }

        const userInfo = await homeApi.getUserInfo();
        const userInfoDomain = mapUserInfoDtoToDomain(userInfo);
        const newUserInfoDb = mapUserInfoDomainToDb(userInfoDomain);
        userInfoDao.setUserInfo(newUserInfoDb);
        return userInfoDomain;
      } catch (error) {
        console.error("Ошибка при получении информации пользователя:", error);
        throw error;
      }
    }
  })(),

  getUserSubscription: (() => {
    let subscriptionPromise: Promise<UserSubscriptionDomain | null> | null =
      null;

    return async () => {
      if (subscriptionPromise) {
        return subscriptionPromise;
      }

      subscriptionPromise = performGetUserSubscription();

      try {
        const result = await subscriptionPromise;
        return result;
      } finally {
        subscriptionPromise = null;
      }
    };

    async function performGetUserSubscription(): Promise<UserSubscriptionDomain | null> {
      try {
        const userSubscription = await homeApi.getUserSubscription();
        return userSubscription ? mapUserSubscriptionDtoToDomain(userSubscription) : null;
      } catch (error) {
        console.error("Ошибка при получении подписки пользователя:", error);
        throw error;
      }
    }
  })(),

  getConfig: (() => {
    let configPromise: Promise<ConfigDomain | null> | null = null;

    return async () => {
      if (configPromise) {
        return configPromise;
      }

      configPromise = performGetConfig();

      try {
        const result = await configPromise;
        return result;
      } finally {
        configPromise = null;
      }
    };

    async function performGetConfig(): Promise<ConfigDomain | null> {
      try {
        const config = await homeApi.getConfig();
        return mapConfigDtoToDomain(config);
      } catch (error) {
        console.error("Ошибка при получении конфигурации:", error);
        throw error;
      }
    }
  })(),

  isEnabledPushNotifications: () => {
    return userSettingsApi.isEnabledPushNotifications();
  },
  setIsEnabledPushNotifications: (isEnabled: boolean) => {
    return userSettingsApi.setIsEnabledPushNotifications(isEnabled);  
  },
  clearUserInfo: () => {
    return userInfoDao.clearUserInfo();
  }
};
